import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

const StyledLink = styled('a')({
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  border: '0',
  '&:focus': {
    position: 'static',
    width: 'auto',
    height: 'auto',
    margin: '0',
    overflow: 'visible',
    clip: 'auto'
  }
});

const VisuallyHiddenLink = ({ href, children, ...props }) => (
  <StyledLink href={href} {...props}>
    {children}
  </StyledLink>
);

VisuallyHiddenLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default VisuallyHiddenLink;
